import React from 'react'

import { Skeleton } from 'components'
import { SKELETON_INFO, SKELETON_ADDRESS } from 'features/Company/constants'
import { BoxItem, BoxAddressItem, BoxDetailItem } from './CompanyDetail'

const SkeletonCompanyDetail: React.FC = () => {
  const base = 'f-company-detail'

  const SkeletonInfo = () => {
    return (
      <div className={`${base}__company-info-content`}>
        <div className={`${base}__title-layout`}>
          <div className={`${base}__product-detail-title`}>
            {<Skeleton.whiteSkeleton width='130px' />}
          </div>
          <div className={`${base}__logo-text`}>
            {<Skeleton.whiteSkeleton width='42px' />}
          </div>
          <div className={`${base}__company-logo`}>
            {
              <Skeleton.whiteSkeleton
                width='120px'
                height='120px'
                borderRadius='8px'
              />
            }
          </div>
        </div>
        <div className={`${base}__description-layout`}>
          {SKELETON_INFO.map((data, index) => {
            return (
              <BoxItem
                key={index}
                title={<Skeleton.whiteSkeleton width={`${data.widthTitle}`} />}
                description={
                  <Skeleton.whiteSkeleton width={`${data.widthDescription}`} />
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  const SkeletonAddress = () => {
    return (
      <div className={`${base}__company-address-content`}>
        <div className={`${base}__title-layout`}>
          <span className={`${base}__product-detail-title`}>
            {<Skeleton.whiteSkeleton width='130px' />}
          </span>
        </div>
        <div>
          <div className={`${base}__description-layout`}>
            <BoxAddressItem
              title={<Skeleton.whiteSkeleton width='74px' />}
              description={
                <>
                  <Skeleton.whiteSkeleton height='18px' width='121px' />
                  <Skeleton.whiteSkeleton height='18px' width='245px' />
                </>
              }
            />
            {SKELETON_ADDRESS.map((data, index) => {
              return (
                <BoxItem
                  key={index}
                  title={
                    <Skeleton.whiteSkeleton width={`${data.widthTitle}`} />
                  }
                  description={
                    <Skeleton.whiteSkeleton
                      width={`${data.widthDescription}`}
                    />
                  }
                />
              )
            })}
          </div>
          <BoxDetailItem
            title={<Skeleton.whiteSkeleton width='74px' />}
            description={<Skeleton.whiteSkeleton width='121px' />}
          />
        </div>
      </div>
    )
  }

  return (
    <div data-testid='skeleton-loading'>
      <SkeletonInfo />
      <SkeletonAddress />
    </div>
  )
}

export default SkeletonCompanyDetail
